import api from "../routes/api";
import { fetchAuthPost } from "./functions";

export const fetchTourOption = async (id_tour_type) => {
  return await fetchAuthPost(api.utils.tourOptionByIdTourType, {
    data: { id_tour_type },
  }).then((r) => r.data.tour_option);
};

export const fetchDateOption = async (id_tour_type, id_tour) => {
  return await fetchAuthPost(api.utils.dateOptionByIdTourAndIdTourType, {
    data: { id_tour_type, id_tour },
  }).then((r) => r.data.date_option);
};

export const fetchBoatOption = async (id_tour_type, id_tour, date) => {
  return await fetchAuthPost(api.utils.boatOptionByIdTourAndDateAndIdTourType, {
    data: { id_tour_type, id_tour, date },
  }).then((r) => r.data.boat_option);
};

export const fetchBoatCapacity = async (id_boat) => {
  return await fetchAuthPost(api.utils.boatCapacity, {
    data: { id_boat },
  }).then((r) => {
    const passenger_capacity_company_policy =
      r.data?.boat_capacity?.passenger_capacity_company_policy;
    const passenger_capacity_registration =
      r.data?.boat_capacity?.passenger_capacity_registration;
    return passenger_capacity_company_policy;
  });
};

export const fetchSeat = async (id_tour_type, id_tour, date, id_boat) => {
  return await fetchAuthPost(
    api.utils.seatByIdTourAndDateAndIdBoatAndIdTourType,
    {
      data: { id_tour, date, id_boat, id_tour_type },
    }
  ).then((r) => r.data.seat);
};

export const fetchAgeGroup = async () => {
  return await fetchAuthPost(api.entry.readGuestAgeSetting).then((r) => {
    const adult_age = r.data.adult_age;
    const child_age = r.data.child_age;
    const infant_age = r.data.infant_age;
    return { adult_age, child_age, infant_age };
  });
};

export const fetchRequestGroupId = async (
  id_tour_type,
  id_tour,
  date,
  id_boat
) => {
  const {
    data: { request_group_id },
  } = await fetchAuthPost(api.utils.requestGroupId, {
    data: { id_tour, date, id_boat, id_tour_type },
  });
  return request_group_id;
};

export const fetchTourDetail = async (id_tour_type, id_tour, date, id_boat) => {
  return await fetchAuthPost(api.utils.tourDetail, {
    data: { id_tour, date, id_tour_type, id_boat },
  }).then((r) => r.data);
};

export const fetchAgentOption = async () => {
  return await fetchAuthPost(api.setting.readAgentList).then((r) => {
    return r.data.map((el) => ({ value: el.id_agent, label: el.agent }));
  });
};

export const fetchDataList = async (id_tour_type, id_tour, date, id_boat) => {
  return await fetchAuthPost(api.entry.readDataList, {
    data: { id_tour_type, id_tour, date, id_boat },
  }).then((r) => r.data);
};
